import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { getCustomerList } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { defaultSAL2070_R01Dto, SAL2070_R01Dto } from "./Dto_SAL2070_R01";
import { useSAL2070_R01Store } from "./Store_SAL2070_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";



interface Props {
	defaultSAL2070_R01HeaderRow: SAL2070_R01Dto;
	processVatRate: (vatType: string) => number;
}

export const Info_SAL2070_R01 = (props: Props) => {

	const { defaultSAL2070_R01HeaderRow, processVatRate } = props;

	// 
	const { vatTypeList, vatIoFlagList, moneyCdList, compCdList, wmsCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { SAL2070_R01DetailList, deletedSAL2070_R01DetailList,
			editSAL2070_R01, setEditSAL2070_R01,
			selectedSAL2070_R01,
			selectedSAL2070_R01DetailList,
	} = useSAL2070_R01Store();


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const addressHandleFoucsId = 'addressInput2';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd'
			},
			searchFunction: async (code: string) => {
				const customerResponse = await getCustomerList('all');
				return customerResponse.data.data.find(value => value.customCd === code);
			},
			extraFilter: () => ({
				customCd: editSAL2070_R01?.customCd || '',
				customNm: editSAL2070_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'taxEmpNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'taxEmpNo',
				empNm: 'taxEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editSAL2070_R01?.taxEmpNo || '',
				empNm: editSAL2070_R01?.taxEmpNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editSAL2070_R01,
		setEditData: setEditSAL2070_R01,
		defaultData: defaultSAL2070_R01Dto,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2070_R01'
	});

	// 거래일자 달력 팝업 상태
	const [tradeDtPickerVisible, setTradeDtPickerVisible] = useState(false);
	const [tradeDtPickerPos, setTradeDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	useEffect(() => {
		const newItemAmt = SAL2070_R01DetailList.filter(item => selectedSAL2070_R01DetailList.includes(item.tradeNo)).reduce((sum, item) => sum + item.totalAmt, 0);
		
		// 조회 시에는 DB 값 그대로 사용, 편집 시에만 자동 계산 적용
		let newVatAmt = editSAL2070_R01?.vatAmt || 0;

		//입력 상황일경우 부가세 계산
		if(editSAL2070_R01?.taxBillNo === '' || editSAL2070_R01?.taxBillNo === undefined || editSAL2070_R01?.taxBillNo === null){
			newVatAmt = newItemAmt * (editSAL2070_R01?.vatRate || 0) / 100;
		}
	
		setEditSAL2070_R01({
			...defaultSAL2070_R01Dto,
			...editSAL2070_R01,
			billAmt: newItemAmt,
			vatAmt: newVatAmt,
		})
	}, [SAL2070_R01DetailList, editSAL2070_R01?.vatType, selectedSAL2070_R01DetailList])


	const handleDateChange = useCallback((field: keyof SAL2070_R01Dto, value: any) => {
		setEditSAL2070_R01({ ...defaultSAL2070_R01Dto, ...editSAL2070_R01, [field]: value })
	}, [editSAL2070_R01])

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		if(name === 'vatType'){
			let vatRateValue = processVatRate(value);
			setEditSAL2070_R01({ 
				...defaultSAL2070_R01Dto,
				...editSAL2070_R01, 
				vatType: value,
				vatRate: vatRateValue,
				vatAmt: editSAL2070_R01?.billAmt ? editSAL2070_R01.billAmt * (vatRateValue) / 100 : 0
			})
			return;
		}

		setEditSAL2070_R01({
			...defaultSAL2070_R01Dto,
			...editSAL2070_R01,
			[name]: value
		});
	}, [editSAL2070_R01]);



	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				
				{/* editSAL2070_R01 : {JSON.stringify(editSAL2070_R01)} <br /> */}
				{/* vatTypeList : {JSON.stringify(vatTypeList)} <br /> */}
				
				<InputForm title="세금계산서No" value={editSAL2070_R01?.taxBillNo || ""} 
					editable={false}
					name="tradeNo" 
					onChange={handleChange} />
				<BRDiv />
				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editSAL2070_R01?.compCd}
					data={compCdList}
					editable={true}
					onChange={handleChange}
				/>
				
				<SingleDateForm
					title="세금계산서발행일자"
					value={editSAL2070_R01?.issuedDt ? new Date(editSAL2070_R01.issuedDt) : new Date()}
					setValue={(value: Date | undefined) => handleDateChange('issuedDt', formatDate(value))}
					editable={true}
					visible={tradeDtPickerVisible}				setVisible={setTradeDtPickerVisible}
					onChange={handleChange}
					pickerPos={tradeDtPickerPos}						setPickerPos={setTradeDtPickerPos}
					wrapperOption={{
						wrapperStyle: "w-[350px] min-w-[350px] mr-[10px] mb-[5px]",
						titleStyle: "w-[120px] min-w-[120px] text-left",
						inputStyle: "w-[180px] min-w-[180px]",
					}}
				/>
				<BRDiv />

				<CodeForm
					label="거래처"
					value={editSAL2070_R01?.customCd || ""}
					custNmValue={editSAL2070_R01?.customNm || ""}
					editable={false}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
			
				<DropDownForm<SysCodeDto> 
							title="세금계산서구분"
							data={vatIoFlagList}
							value={editSAL2070_R01?.tradeType}
							name="tradeType" 
							editable={false}
							initLabelLess={true}
							onChange={handleChange} />
				<BRDiv />

				
				<DropDownForm
						title="부가세구분" 
						value={editSAL2070_R01?.vatType}
						name="vatType"
						initLabelLess={true}
						data={vatTypeList}
						editable={true}
						onChange={handleChange} />
				<InputForm
					title="세율"
					value={(editSAL2070_R01?.vatRate || "0") + "%" }
					editable={false}
					name="vatRate"
					onChange={handleChange} />
				<BRDiv />
				<InputForm
					title="공급가액"
					value={editSAL2070_R01?.billAmt ?? 0}
					editable={false}
					name="billAmt"
					onChange={handleChange} />
				<BRDiv />
				<InputForm
					title="부가세액"
					value={editSAL2070_R01?.vatAmt ?? 0}
					editable={false}
					name="vatAmt"
					onChange={handleChange} />
				<BRDiv />

				<CodeForm
					label="담당자"
					value={editSAL2070_R01?.taxEmpNo || ""}
					custNmValue={editSAL2070_R01?.taxEmpNm || ""}
					editable={true}
					handleFoucsId={empInfoHandleFoucsId}
					name="taxEmpNo"
					handleChange={getFieldHandlers('taxEmpNo').onChange}
					onDoubleClick={getFieldHandlers('taxEmpNo').onDoubleClick}
					onKeyDown={getFieldHandlers('taxEmpNo').onEnterKeyDown}
				/>

				<BRDiv />
				<InputForm
					title="비고"
					value={editSAL2070_R01?.remark || ""}
					editable={true}
					name="remark"
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
				<BRDiv />
				{ editSAL2070_R01?.taxBillNo && editSAL2070_R01?.taxBilling === 'Y' && (
						<div className="text-red-400 font-bold text-xs">
							세금계산서No가 존재하는 발행된 세금계산서 선택시 삭제만 가능하며 , 삭제기능 동작시 거래전표 선택 여부없이 전부 삭제 됩니다
						</div>
					)
				}
				
		</div>
	)
}